import { copy } from "../../config/copy.js";
import { h } from "../../core/dom.js";
import { accordion } from "../components/accordion.js";
import { devBadge, devPanel } from "../components/devPanel.js";
import { settingsSection, voiceSection } from "../components/settings.js";
import { themePicker } from "../components/themePicker.js";

const STEPS = [
  ["📷", "Inquadra", "Apri la fotocamera e tieni il cane dentro il riquadro, con muso e corpo visibili."],
  ["🔍", "Analizza", "Tocca l'anteprima, registra una clip o usa la modalità Live: PAWS legge espressione e postura e riconosce 14 stati d'animo."],
  ["💬", "Capisci", "Vedi lo stato più probabile e, se vuoi, chiedi una spiegazione dettagliata con consigli pratici."],
  ["👍", "Aiutaci", "Dicci se abbiamo indovinato: ogni risposta rende PAWS più preciso."]
];

const PRIVACY = "La modalità Live e l'analisi rapida avvengono direttamente sul tuo telefono. Per l'analisi avanzata e la spiegazione dettagliata la foto viene elaborata online solo per il tempo necessario e non viene conservata. Resta salvata solo se scegli di condividerla insieme al tuo feedback.";

const CAVEAT = "PAWS interpreta segnali visivi e può sbagliare. Non sostituisce il parere di un veterinario o di un educatore cinofilo: se il tuo cane mostra dolore o cambiamenti improvvisi di comportamento, rivolgiti a un professionista.";

export function infoView(app) {
  const reload = () => app.router.go("/info");
  const version = h("button", { class: "version-tap", type: "button", "aria-label": `Versione ${app.config.version}` },
    `Versione ${app.config.version}`);
  version.addEventListener("click", () => {
    const state = app.devMode.tap();
    if (state.changed) {
      app.toast(copy.devUnlocked, "success");
      reload();
      return;
    }
    if (!state.unlocked && state.missing <= 3) app.toast(copy.devHint(state.missing), "info", 1500);
  });
  const lock = () => {
    app.devMode.lock();
    app.toast(copy.devLocked, "info");
    reload();
  };

  const classes = app.classifier.metadata?.classes || [];
  const blocks = accordion([
    {
      id: "come",
      icon: "🧭",
      title: "Come funziona",
      content: h("ol", { class: "steps" }, STEPS.map(([icon, title, text]) =>
        h("li", {}, h("span", { class: "step-icon" }, icon), h("div", {}, h("strong", {}, title), h("p", {}, text)))))
    },
    classes.length ? {
      id: "classi",
      icon: "🐕",
      title: "Cosa riconosce",
      content: h("ul", { class: "class-list" }, classes.map((item) =>
        h("li", {}, h("strong", {}, `${item.emoji} ${item.label_it}`), h("span", { class: "muted" }, item.description_it))))
    } : null,
    {
      id: "aspetto",
      icon: "🎨",
      title: "Aspetto",
      content: h("div", {}, h("p", { class: "muted" }, "Scegli come vuoi vedere PAWS: segue il tuo telefono oppure resta sempre chiara o scura."), themePicker(app.theme))
    },
    { id: "voce", icon: "🔊", title: copy.voiceTitle, content: voiceSection(app) },
    { id: "impostazioni", icon: "⚙️", title: "Impostazioni", content: settingsSection(app, reload) },
    { id: "privacy", icon: "🔒", title: "Privacy", content: h("p", {}, PRIVACY) },
    { id: "sapere", icon: "ℹ️", title: "Da sapere", content: h("p", {}, CAVEAT) },
    app.devMode.enabled ? { id: "dev", icon: "🛠", title: "Sviluppatore", badge: devBadge(), content: devPanel(app, lock) } : null
  ].filter((block) => !block || block.content));

  const element = h("section", { class: "view" },
    h("div", { class: "about-logo" }, "🐾"),
    h("h1", { class: "center" }, "PAWS"),
    h("p", { class: "center muted" }, "Pet Affect Watch System"),
    blocks.element,
    h("p", { class: "center" }, version));
  return { element, blocks };
}
